<template lang="pug">
  vm-prompt(vm-size="medium" @vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(autofocus :placeholder='$t("tasks.name_placeholder")' :danger="$v.form.title.$invalid && $v.form.title.$model" :danger-text="$t('validation.required', { attribute: $t('tasks.name') })" v-model="form.title" :label='$t("tasks_modal.title")').vm-select-row
          vm-textarea(autofocus :placeholder='$t("tasks.desc_placeholder")' :danger="$v.form.desc.$invalid && $v.form.desc.$model" :danger-text="$t('validation.required', { attribute: $t('tasks.name') })" v-model="form.desc" :label='$t("tasks.desc_task")').vm-select-row
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="space-around", vm-align="center", vm-w=6 )
        b-form-group
          vm-date-picker(:placeholder='$t("tasks.start_date")' :label='$t("tasks_modal.start_date")' :danger="$v.form.start_date.$invalid && $v.form.start_date.$model" :danger-text="$t('validation.required', { attribute: $t('tasks_modal.start_date') })" v-model="form.start_date").vm-select-row
      vm-col(vm-justify="space-around", vm-align="center", vm-w=6)
        b-form-group
          vm-date-picker(:placeholder='$t("tasks.end_date")' :label='$t("tasks_modal.end_date")' :danger="$v.form.end_date.$invalid && $v.form.end_date.$model" :danger-text="$t('validation.required', { attribute: $t('tasks_modal.end_date') })" v-model="form.end_date").vm-select-row
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="space-around", vm-align="center", vm-w=6)
        b-form-group
          vm-select(autofocus :placeholder='$t("tasks.name_placeholder")' :danger="$v.form.foliable_type.$invalid && $v.form.foliable_type.$model" :danger-text="$t('validation.required', { attribute: $t('tasks.type') })" v-model="form.foliable_type" :label='$t("tasks_modal.type")').vm-select-row
            vm-select-item(v-for="item in types" :key="item.id" :text="item.name" :value="item.url")
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group(v-if="form.foliable_type !== undefined && form.foliable_type !== ''")
          vm-typeahead( autocomplete="false" :url="form.foliable_type" :label="$t('tasks_modal.folio')" :serializer="item => item.folio" v-model="form.foliable"  :data="catalog[form.foliable_type]" :filter="query => `?param=${query},folio`" @input-change="autoCompleteFunc").vm-select-row
            template(slot-scope="{data}")
              vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data" v-bind:text="item.text" v-for="item,index in data")
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-typeahead(url="users" :label='$t("tasks_modal.assign_to")' :serializer="item => item.name" :danger="$v.form.assign_to_ids.$invalid && $v.form.assign_to_ids.$model"  :data="catalog.users" placeholder='responsable' v-model="form.user" :filter="query => `?param=${query},name`" @input-change="autoCompleteFunc").vm-select-row
            template(slot-scope="{data}")
              vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data" v-bind:text="item.text"  v-for="item,index in data" @click="addAsigned(item.data)")
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
           vm-button(@click="addAsigned(form.user)" v-model="form.ids_asigned" size=12 icon="plus-outline" color="white" textColor="black").vm-button-row {{$t('tasks_modal.assign_to_another')}}
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=6).vm-select-row
        b-form-group
          ul.vm-select-row
            li(v-for="(item, index) in form.assign_to_ids" :key="item.id").vm-select-row
              vm-row
                vm-col(vm-w="10")
                  div {{item.name}}
                vm-col(vm-w="2" vm-type="flex" vm-align="center")
                  vm-button(icon="backspace-outline" color="white" textColor="black" @click="deleteAssigned(index)")
      vm-col(vm-align="center"  vmType="grid", vm-w=6)
        vm-button(size=12 @click="$refs.file.click()" iconAfter=true icon="file-add-outline" color="white" textColor="black").vm-button-row {{$t('tasks_modal.attatchment')}}
        input(type="file" ref="file" style="display: none" v-on:change="handleFileUpload()" accept="application/msword, image/jpeg, image/x-png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document")
      vm-col(vm-align="center"  vmType="grid", vm-w=6)
        div {{getFileName(form.file)}}
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Tasks')

export default {
  name: 'ModalTasks',
  mixins: [ModalMixin1],
  data: () => ({
    types: [
      {
        name: 'Otro',
        url: '',
        type: ''
      },
      {
        name: 'Cotizacion',
        url: 'quotations',
        type: 'App\\Quotation'
      },
      {
        name: 'Venta',
        url: 'sales',
        type: 'App\\Sale'
      },
      {
        name: 'Ordenes de Compra',
        url: 'purchaseOrders',
        type: 'App\\PurchaseOrder'
      }],
    foliable_type: '',
    url: ''
  }),
  validations () {
    return {
      form: {
        title: {
          required
        },
        desc: {
          required
        },
        foliable_type: '',
        foliable: '',
        start_date: {
          required
        },
        end_date: {
          required
        },
        user: {
        },
        assign_to_ids: {
          required
        },
        file: '',
        created_by_id: '',
        customer_id: '',
        supplier_id: '',
        foliable_id: ''
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog', 'tasks'])
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog',
      'addTaskAttachment',
      'editTaskAttachment'
    ]),
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    deleteAssigned (value) {
      this.form.assign_to_ids.splice(this.form.assign_to_ids.indexOf(value), 1)
    },
    addAsigned (user) {
      if (!this.form.assign_to_ids) {
        this.form.assign_to_ids = []
      }

      let currentArray = [...this.form.assign_to_ids]
      currentArray.push(this.form.user)
      this.form.assign_to_ids = [...new Set(currentArray)]
    },
    getAsignedList (newList) {
      this.form.assign_to_ids = newList
    },
    getFileName (file) {
      if (file) {
        return file.name === undefined ? this.form.file.attachment : this.form.file.name
      } else {
        return ''
      }
    },
    filterAssignedIds (users) {
      return users.map((item) => item.id)
    },
    setFoliableType (value) {
      console.log(value)
      this.form.foliable_type = value ? this.types.find(item => item.url === value).type : ''
    },
    setIds (foliable) {
      const isFoliable = this.form.foliable
      this.form = {
        ...this.form,
        foliable_id: isFoliable ? isFoliable.id : null,
        supplier_id: isFoliable.details && isFoliable.details[0] ? isFoliable.details[0].supplier_id : null,
        customer_id: isFoliable.customer ? isFoliable.customer.id : null
      }
    },
    async saveRecord () {
      this.setFoliableType(this.form.foliable_type)
      this.form.foliable && this.setIds(this.form.foliable)
      this.form.assign_to_ids = this.filterAssignedIds(this.form.assign_to_ids)
      this.form.created_by_id = this.$auth.user().id
      this.isAdd ? await this.addRecord(this.form) : await this.editRecord(this.form)
      if (this.form.file) {
        this.isAdd ? await this.addTaskAttachment({ id: this.tasks[0].id, file: this.form.file }) : this.editTaskAttachment({ id: this.form.id, file: this.form.file })
      }
      this.close()
    },
    handleFileUpload () {
      this.form.file = this.$refs.file.files[0]
    },
    removeAssigned (value) {
      this.ids_asigned = this.form.assign_to_ids.filter(item => item !== value)
    },
    saveAttachment () {
      this.addAttachment({ file: this.form.file, sale_id: this.sale_id, description: this.description })
    },
    close () {
      this.setModalVisible(false)
      this.ids_asigned = []
      this.form = {}
    }
  }
}
</script>

<style lang="scss">
.vm-select-row{
  margin: 2px;
  padding: 10px;
  font-weight: bold;
}
.vm-button-row{
  border: 1px solid grey;
  border-width: solid grey 0px;
  border-radius: 14px;
  margin-left: 14px;
  margin-right: 14px;
  justify-items: center;
}
</style>
